module.exports = __webpack_public_path__ + "static/media/arrow-down-yl.432a515b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down-yl.svg
// module id = 377
// module chunks = 0